<mat-card *ngFor="let section of getFilteredGroupSections()" class="cl-device-section">
    <div fxLayout="column">
        <mat-card-title>
            <span [ngClass]="accentText" class="cl-section-header">{{section.displayText}}</span>
        </mat-card-title>

        <mat-card-content>
            <div fxLayout="row wrap">
                <dl-device-input
                    class="top"
                    [deviceInfo]="deviceInfo"
                    [deviceInput]="input"
                    [deviceInputForm]="deviceInputForm"
                    *ngFor="let input of orderInputs(section.$controlInputs)"
                    [setDeviceInfo]="setDeviceInfo"
                >
                </dl-device-input>
            </div>

            <dl-device-grouping
                [deviceInfo]="deviceInfo"
                [grouping]="section"
                [deviceInputForm]="deviceInputForm"
                [setDeviceInfo]="setDeviceInfo"
            >
            </dl-device-grouping>
        </mat-card-content>
    </div>
</mat-card>
